export function isObj(value) {
  return Object.prototype.toString.call(value) === "[object Object]";
}

export function toBoolean(value) {
  const booleanValues = { true: true, false: false };
  return (booleanValues)[value];
}
